import { FreeSpinsSyncFailure } from "@/v2/types/FreeSpinsSync/FreeSpinsSyncResult.interface";

/** Provider game codes that match no game configuration: a code, no game id. */
export const getUnknownGameCodes = (failures: FreeSpinsSyncFailure[]): string[] =>
  Array.from(
    new Set(
      failures
        .filter(({ gameId, gameCode }) => gameId === undefined && gameCode !== undefined)
        .map(({ gameCode }) => gameCode as string),
    ),
  );
